<!--
	Legend panel for the Interventions tab: static text only, as the interventions tool is the
	crash-risk calculator reached by selecting an intersection with Identify.
-->
<script lang="ts">
	import LegendSection from '#lib/components/LegendSection.svelte';
</script>

<div class="legendBox">
	<LegendSection heading="Crash-risk calculator">
		<p>
			Select an intersection using the <strong>Identify</strong>
			tool to propose and test SafeIntersections interventions.
		</p>
	</LegendSection>
</div>
